import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import { ClientWebhookContent } from "../components/ClientWebhookContent";
import { PublicationsTabContent } from "../components/PublicationsTabContent";
import { useJobSourceClientDetailsBreadcrumbs } from "../hooks/useJobSourceClientDetailsBreadcrumbs";

import ModernPageLayout from "@/components/layout/ModernPageLayout";
import Tabs from "@/components/ui/v2/tabs";

const TAB_IDS = ["webhooks", "publications"] as const;
type TabId = (typeof TAB_IDS)[number];

function isValidTabId(value: string | null): value is TabId {
  return value !== null && TAB_IDS.includes(value as TabId);
}

function JobSourceClientDetailPage() {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const { breadcrumbs } = useJobSourceClientDetailsBreadcrumbs();

  const tabFromUrl = searchParams.get("tab");
  const activeTabId = isValidTabId(tabFromUrl) ? tabFromUrl : "webhooks";

  const tabs = [
    {
      id: "webhooks",
      label: t("integrations.cockpit.jobSource.tabs.webhooks"),
      content: (
        <div className="mt-6">
          <ClientWebhookContent />
        </div>
      ),
    },
    {
      id: "publications",
      label: t("integrations.cockpit.jobSource.tabs.publications"),
      content: (
        <div className="mt-6">
          <PublicationsTabContent />
        </div>
      ),
    },
  ];

  const handleTabChange = (tab: { id?: string }) => {
    if (tab.id && isValidTabId(tab.id)) {
      setSearchParams({ tab: tab.id }, { replace: true });
    }
  };

  return (
    <ModernPageLayout breadcrumbs={breadcrumbs}>
      <div className="mt-6">
        <Tabs
          tabs={tabs}
          defaultTabId={activeTabId}
          onChange={handleTabChange}
        />
      </div>
    </ModernPageLayout>
  );
}

export default JobSourceClientDetailPage;
